import { gql } from 'react-apollo';

export const updateSettings = gql`
  mutation updateSettings($input: UpdateSettingsInput!) {
    updateSettings(input: $input) {
       settings {
         passwordResetTokenLifetime: password_reset_token_lifetime
       }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/settings/mutations/updateSettings.js